import { Component, OnInit } from '@angular/core';
import { RestService } from '../rest.service';
import { LoginComponent } from '../login/login.component';
import { UserService } from '../user.service';

@Component({
  selector: 'app-cuadrante',
  templateUrl: './cuadrante.component.html',
  styleUrls: ['./cuadrante.component.scss']
})
export class CuadranteComponent implements OnInit {

  datos: any[] = [];
  categorias: any[] = [];
  employes: any[] = ['Juan', 'Asun', 'Tere', 'Damian', 'José'];
  turnos: any[] = [];
  turno_selected: any = {
    'alias' : '',
    'color' : 'lightgray'
  };
  custom = '10:00';
  mes_actual: number = 0;
  categoria_emp = 0;
  totales: any[] = [];
  meses = [
    {
      'id': 1,
      'mes' : 'Enero'
    },
    {
      'id': 2,
      'mes' : 'Febrero'
    },
    {
      'id': 3,
      'mes' : 'Marzo'
    },
    {
      'id': 4,
      'mes' : 'Abril'
    },
    {
      'id': 5,
      'mes' : 'Mayo'
    },
    {
      'id': 6,
      'mes' : 'Junio'
    },
    {
      'id': 7,
      'mes' : 'Julio'
    },
    {
      'id': 8,
      'mes' : 'Agosto'
    },
    {
      'id': 9,
      'mes' : 'Septiembre'
    },
    {
      'id': 10,
      'mes' : 'Octubre'
    },
    {
      'id': 11,
      'mes' : 'Noviembre'
    },
    {
      'id': 12,
      'mes' : 'Diciembre'
    }
  ];

  check: boolean = false;

  month = 0;

  constructor(
    public rest: RestService,
    public user: UserService) {
    let d = new Date();
    this.month = d.getMonth();
    this.GetTurnos();
    // this.GetSumatorios();
    this.getCategorias();
  }

  ngOnInit() {
  }

  GetData() {
    this.user.loading = true;
    if ( this.categoria_emp === 0 || this.month === 0 ) {
      alert('Elige categoria de empleados');
    } else {
      this.GetSumatorios();
      this.rest.GetCuadrante(this.month, this.categoria_emp).subscribe(
        (data) => {
          this.datos = data['data']['data'];
          this.employes = data['data']['employes'];
          this.user.loading = false;
      }, (error) => {
        this.user.loading = false;
      });
    }
  }

  CopyAll() {
    this.user.loading = true;
    const option = confirm('¿ Duplicar mes actual al siguiente mes ?');

    if ( option ) {

      this.rest.Duplicate(this.month).subscribe((data) => {
        console.log(data);
        this.user.loading = false;
      });

    }

  }

  Changes(index, index2, datos) {

    const d = new Date();

    if ( this.month === 0 || this.turno_selected.alias === '' ) {
      alert('Comprueba Mes y turno seleccionado');
    } else {

      const newDate = new Date(d.getFullYear() + '-' + this.month + '-' + datos.dia);

      this.datos[index].valor[index2] = this.turno_selected;

      this.rest.PostChanges(
        this.user.formatDate(newDate),
        this.employes[index2].id,
        this.datos[index].valor[index2].id
      ).subscribe( (data) => { });

    }

  }

  GetTurnos() {
    this.rest.getTurnos().subscribe( (data) => {
      this.turnos = data['data'];
    });
  }

  getCategorias() {
    this.rest.getCategorias().subscribe( (data) => {
      this.categorias = data['data'];
    });
  }

  GetSumatorios() {
    this.rest.GetTotales(this.categoria_emp).subscribe( (data) => {
      this.totales = data['data'];
    },(error) => {
      this.user.loading = false;
    });
  }

  SelectTurno(turno) {
    this.turno_selected = turno;
  }

  CreateNewTurno() {

    const option = confirm('¿ Desea crear un turno con este valor ?');

    if ( option ) {

      this.rest.CreateTurno(this.custom).subscribe( (data) => {
        this.GetTurnos();
      }, (error) => {
        alert('Turno ' + this.custom + ' ya creado');
        this.GetTurnos();
      });
    }

  }

}
